import React from 'react';
import './slider-woodtecperforated.css';
import Woodtecperforated1 from '../../images/woodtec/6.webp';
import Woodtecperforated2 from '../../images/woodtec/6.webp';

function slider() {
	return (
	  
	<>
	<div id="slider-woodtecperforated">
		<div id="carouselExampleIndicators3" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators3" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators3" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Woodtecperforated1} alt="Woodtecperforated1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>PERFORATED ACOUSTIC PANEL</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Woodtecperforated2} alt="Woodtecperforated2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>PERFORATED ACOUSTIC PANEL</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators3" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators3" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;